import { DepositPaymentType } from '../../../../../api/types/accounting/deposit-payment-type';

export interface PendingDepositPaymentsFilterType {
  shouldReceiveCrm: boolean;
  shouldReceivePayments: boolean;
  startFromDate: Date | null;
  toDate: Date | null;
  paymentType: DepositPaymentType[];
  checkDueDateFrom: Date | null;
  checkDueDateTo: Date | null;
}

export const defaultPendingDepositPaymentsFilter =
  (): PendingDepositPaymentsFilterType => ({
    shouldReceiveCrm: true,
    shouldReceivePayments: true,
    startFromDate: null,
    toDate: null,
    paymentType: [],
    checkDueDateFrom: null,
    checkDueDateTo: null,
  });
